import { ReservationChangeQuestionnaire } from "@/components/EventReservation/ReservationChange/ReservationChangeQuestionnaire";
import { QuestionnaireFlowQuestion } from "@/types/question.types";
import { useParams } from "react-router-dom";

type Props = {};

const questions: QuestionnaireFlowQuestion[] = [
  {
    slug: "reservation-change",
    title: "예약 변경이 필요하신가요?",
    subtitle: `급한 일이 생기셨나요?
그럴 수도 있죠! (다만, 함께할 오프 멤버들이 슬퍼해요🥹)

소중한 약속이기에 약속일 2일 전 (월요일 자정) 이후에는
취소/변경시 환불이 어려워요. 😭

일정을 변경하시려면
현재 예약을 취소하고, 새로운 일정으로 다시 신청해주세요.

예약을 취소하시면 결제 금액은 3~7일 이내 환불됩니다. 🪄
`,
    type: "text",
    category: "reservation",
    extra: {},
  },
  {
    slug: "reservation-change-reason",
    title: "취소 이유를 여쭤봐도 될까요?",
    subtitle: "더 나은 서비스를 제공하기 위해 취소 이유를 알려주세요.",
    type: "select_single",
    category: "reservation",
    extra: {
      options: [
        {
          id: 1,
          value: "NEW_SCHEDULE_DIFFICULT",
          displayText: "새로운 장소/날짜 일정이 어려워요",
        },
        {
          id: 2,
          value: "WILL_REBOOK",
          displayText: "다시 예약할거에요",
        },
        {
          id: 3,
          value: "NOT_FEELING_WELL",
          displayText: "몸이 안좋아요",
        },
        {
          id: 4,
          value: "WORK_LATE",
          displayText: "퇴근이 늦어져서 시간에 못맞출거 같아요",
        },
        {
          id: 5,
          value: "WEATHER",
          displayText: "날씨",
        },
        {
          id: 6,
          value: "UNEXPECTED_SITUATION",
          displayText: "예상치 못한 상황이 생겼어요",
        },
        {
          id: 7,
          value: "CHANGED_MIND",
          displayText: "마음이 바꼈어요",
        },
        {
          id: 8,
          value: "AFRAID_TO_GO_OUT",
          displayText: "막상 나가려니 두려워요",
        },
        {
          id: 9,
          value: "OTHER",
          displayText: "기타",
        },
      ],
    },
  },
  {
    slug: "reservation-cancel-confirmation",
    title: "다음에 꼭 다시 만나요!",
    subtitle: `예약 취소가 완료되었어요.
이번에 함께하지 못하게 되어 아쉽지만,
미리 알려주셔서 감사해요! ☺️

약속일 2일 전 (월요일 자정) 취소라면 환불 정책에 따라
3-7일이내에 전액 환불될 예정이에요.

곧 만나뵐 수 있기를 기다리고 있을게요! 🦄`,
    type: "text",
    category: "reservation",
    extra: {},
  },
];

export function ReservationChangePage({}: Props) {
  const { reservationId } = useParams<{ reservationId: string }>();

  if (!reservationId) {
    return <div>Invalid reservation ID</div>;
  }

  return <ReservationChangeQuestionnaire questions={questions} reservationId={reservationId} />;
}
